var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"bordered-fieldset"},[(_vm.legend)?_c('legend',{staticClass:"bordered-fieldset__legend"},[_vm._v("\n    "+_vm._s(_vm.legend)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }